import { SET_PROPERTY_CONTACTS, UPDATE_PROPERTY_CONTACTS, PROPERTY_CONTACT_FAILED } from '../../types';

const initialState = { contacts: [] };

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_PROPERTY_CONTACTS:
            return {
                ...state,
                contacts: [...payload]
            };
        case UPDATE_PROPERTY_CONTACTS:
            return {
                ...state,
                contacts: [...payload]
            };
        case PROPERTY_CONTACT_FAILED:
            return {
                ...state,
                contacts: []
            };
        default:
            return state;
    }
}